import {createSlice, Draft, PayloadAction} from '@reduxjs/toolkit';
import {stateDate} from '../../../../utils/formatDate';
import {startOfMonth, subMonths} from 'date-fns';

import {defaultFilter} from '../../../../utils/chartsData';
import {createMultiOptions} from "../../../../utils/createOptions";

const finedData = ['date', 'groupingKey', 'totalCount'];

interface IVisitChartsOptions {
    count: number;
    acceptedCount: number;
    notAcceptedCount: number;
    date: string;
    groupingKey: string;
}

interface ISignalChartsOptions {
    count: number;
    skippedCount: number;
    handledCount: number;
    completedCount: number;
    date: string;
    groupingKey: string;
}

const boardName = localStorage.getItem('boardName');
const UNCATHEGORIZED_ALIAS = 'Другое';

const initialState: any = {
    data: JSON.parse(localStorage.getItem('charts') as string) || [],
    chartsList: JSON.parse(localStorage.getItem('chartsList') as string) || [],
    selectChartsType:
        JSON.parse(localStorage.getItem('chartsList') as string) || {},
    defaultDesktop:
        JSON.parse(localStorage.getItem('defaultDesktop') as string) || '0',
    desktopList: [],
    listSetting: [],
    reorderedOptions: {},
    desktopName: boardName,
    groupFilters: {
        subgroup: [],
        group: [],
        category: [],
        subcategory: [],
        sku: [],
        pos: [],
        chain: [],
    },
    signalFiltersOptions: {
        contract: [],
        pos: [],
        chain: [],
        city: [],
        region: [],
        area: [],
    },
    desktopInputValues: [
        {
            generalFilters: {
                fromDate: stateDate(startOfMonth(subMonths(new Date(), 0))),
                toDate: stateDate(new Date()),
            },
        },
    ],
    desktopData: {},
    modalFilters: {
        ...defaultFilter,
        groupFilters: {
            subgroup: [],
            group: [],
            category: [],
            subcategory: [],
            sku: [],
            pos: [],
            chain: [],
        },
    },
    pending: {},
};

export const chartsSlice = createSlice({
                                           name: 'chartsList',
                                           initialState,
                                           reducers: {
                                               reducerChartsInputValues: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   const {id, value} = action.payload;
                                                   const name = Object.keys(value)[0];

                                                   if (state.desktopInputValues && state.desktopInputValues[id]) {
                                                       const generalFilters =
                                                           state.desktopInputValues[id].generalFilters || {};
                                                       const hasNameGeneralFilters =
                                                           generalFilters && generalFilters.hasOwnProperty(name);
                                                       const initialChain =
                                                           state.groupFilters && state.groupFilters.chain
                                                           ? state.groupFilters.chain
                                                           : [];
                                                       let filteredChains = [...initialChain];

                                                       const inputRegions =
                                                           value.regions && Array.isArray(value.regions) ? value.regions : [];
                                                       const generalRegions =
                                                           generalFilters && Array.isArray(generalFilters.regions)
                                                           ? generalFilters.regions
                                                           : [];

                                                       if (inputRegions.length > 0 || generalRegions.length > 0) {
                                                           if (inputRegions.length > 0) {
                                                               filteredChains = filteredChains.filter(
                                                                   (el: any) =>
                                                                       el &&
                                                                       Array.isArray(el.regions) &&
                                                                       el.regions.some((region: number) =>
                                                                                           inputRegions.includes(region),
                                                                       ),
                                                               );
                                                           } else {
                                                               filteredChains = filteredChains.filter(
                                                                   (el: any) =>
                                                                       el &&
                                                                       Array.isArray(el.regions) &&
                                                                       el.regions.some((region: number) =>
                                                                                           generalRegions.includes(region),
                                                                       ),
                                                               );
                                                           }
                                                       }

                                                       if (generalFilters && generalFilters.retailChains) {
                                                           const valuesObj = state.desktopInputValues[id];
                                                           Object.keys(valuesObj).forEach((key: string) => {
                                                               const el = valuesObj[key];
                                                               if (el && typeof el === 'object') {
                                                                   state.desktopInputValues[id][key] = {
                                                                       ...el,
                                                                       retailChains:
                                                                           el.retailChains && Array.isArray(el.retailChains)
                                                                           ? el.retailChains.filter((rid: any) =>
                                                                                                        filteredChains.some(
                                                                                                            (chain: any) => chain && chain.value === rid,
                                                                                                        ),
                                                                           )
                                                                           : [],
                                                                   };
                                                               }
                                                           });
                                                       }

                                                       if (inputRegions.length === 0) {
                                                           filteredChains = [...initialChain];
                                                       }

                                                       state.globalChainOptions = filteredChains;

                                                       Object.keys(state.desktopInputValues[id]).forEach((key) => {
                                                           if (key !== 'generalFilters') {
                                                               if (
                                                                   state.desktopInputValues[id][key] &&
                                                                   typeof state.desktopInputValues[id][key] === 'object'
                                                               ) {
                                                                   const hasName =
                                                                       state.desktopInputValues[id][key].hasOwnProperty(name);
                                                                   if (!hasName) {
                                                                       state.desktopInputValues[id][key] = {
                                                                           ...state.desktopInputValues[id][key],
                                                                           ...value,
                                                                       };
                                                                   } else {
                                                                       if (hasNameGeneralFilters) {
                                                                           const currentVal = state.desktopInputValues[id][key][name];
                                                                           const generalVal = generalFilters[name];
                                                                           const sortedArray1 =
                                                                               name === 'fromDate' ||
                                                                               name === 'toDate' ||
                                                                               !Array.isArray(currentVal)
                                                                               ? currentVal
                                                                               : currentVal.slice().sort();
                                                                           const sortedArray2 =
                                                                               name === 'fromDate' ||
                                                                               name === 'toDate' ||
                                                                               !Array.isArray(generalVal)
                                                                               ? generalVal
                                                                               : generalVal.slice().sort();

                                                                           if (
                                                                               JSON.stringify(sortedArray1) ===
                                                                               JSON.stringify(sortedArray2)
                                                                           ) {
                                                                               if (value[name] && value[name].length > 0) {
                                                                                   state.desktopInputValues[id][key] = {
                                                                                       ...state.desktopInputValues[id][key],
                                                                                       ...value,
                                                                                   };
                                                                               } else {
                                                                                   delete state.desktopInputValues[id][key][name];
                                                                               }
                                                                           }
                                                                       }
                                                                   }
                                                               }
                                                           } else {
                                                               state.desktopInputValues[id].generalFilters = {
                                                                   ...state.desktopInputValues[id].generalFilters,
                                                                   ...value,
                                                               };
                                                           }
                                                       });
                                                   } else {
                                                       state.desktopInputValues = {
                                                           ...state.desktopInputValues,
                                                           [id]: {
                                                               generalFilters: {...defaultFilter, ...value},
                                                           },
                                                       };
                                                   }
                                               },
                                               reducerGetDesktops: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {desktopList, orders, defaultDesktop, settingCharts} =
                                                   action.payload || {};
                                                   state.settingCharts = settingCharts || state.settingCharts;
                                                   state.defaultDesktop = defaultDesktop || state.defaultDesktop;
                                                   state.desktopList = Array.isArray(desktopList) ? desktopList : [];
                                                   const listStr = localStorage.getItem('selectedChartsTabs');
                                                   const list = listStr ? JSON.parse(listStr) : null;
                                                   if (Array.isArray(state.desktopList)) {
                                                       state.desktopList.forEach((el: any) => {
                                                           state.listSetting = list || [
                                                               'project',
                                                               'contracts',
                                                               'region',
                                                               'areas',
                                                               'сhains',
                                                               'date',
                                                           ];
                                                       });
                                                   }
                                                   state.reorderedOptions = orders || state.reorderedOptions;
                                               },
                                               reducerGetSignalFilterOptions: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {contract, pos, chain, city, region, area} = action.payload || {};
                                                   state.signalFiltersOptions.contract = createMultiOptions(contract);
                                                   state.signalFiltersOptions.pos = createMultiOptions(pos?.map((o: any) =>  o.pos));
                                                   state.signalFiltersOptions.chain = createMultiOptions(chain);
                                                   state.signalFiltersOptions.city = city || [];
                                                   state.signalFiltersOptions.region = createMultiOptions(region);
                                                   state.signalFiltersOptions.area = createMultiOptions(area);
                                               },
                                               reducerDesktopName: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const payload = action.payload || [];
                                                   state.desktopName = payload;
                                                   state.desktopList = payload;
                                                   const findItem = Array.isArray(payload)
                                                                    ? payload.find(
                                                           (el: any) =>
                                                               el && el.id && el.id.toString() === state.defaultDesktop,
                                                       )
                                                                    : null;
                                                   if (!Array.isArray(state.desktopList) || state.desktopList.length === 0) {
                                                       state.defaultDesktop = null;
                                                       localStorage.removeItem('defaultDesktop');
                                                   } else {
                                                       if (!findItem) {
                                                           state.defaultDesktop =
                                                               state.desktopList[0] && state.desktopList[0].id
                                                               ? state.desktopList[0].id.toString()
                                                               : state.defaultDesktop;
                                                       }
                                                       localStorage.setItem(
                                                           'defaultDesktop',
                                                           JSON.stringify(state.defaultDesktop),
                                                       );
                                                   }
                                               },
                                               reducerDesktopSetting: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, value, order} = action.payload || {};
                                                   state.listSetting = value || state.listSetting;
                                                   state.defaultDesktop = id ? id.toString() : state.defaultDesktop;
                                                   const setting = state.listSetting;
                                                   state.reorderedOptions = order || state.reorderedOptions;
                                                   localStorage.setItem('selectedChartsTabs', JSON.stringify(setting));
                                                   localStorage.setItem(
                                                       'defaultDesktop',
                                                       JSON.stringify(state.defaultDesktop),
                                                   );
                                               },
                                               reducerEditDesktop: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, name} = action.payload || {};
                                                   if (state.desktopList && Array.isArray(state.desktopList)) {
                                                       const index = state.desktopList.findIndex(
                                                           (el: any) => el && el.id && el.id.toString() === id,
                                                       );
                                                       if (index !== -1) {
                                                           state.desktopList[index] = {
                                                               ...state.desktopList[index],
                                                               name: name,
                                                           };
                                                       }
                                                   }
                                               },
                                               reducerEditOrderDesktop: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   state.desktopList = Array.isArray(action.payload)
                                                                       ? action.payload
                                                                       : state.desktopList;
                                               },
                                               reducerAddCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const newChartsList =
                                                       action.payload && action.payload.chartsList
                                                       ? action.payload.chartsList
                                                       : [];
                                                   const chartsList = [...(state.chartsList || []), newChartsList];
                                                   state.chartsList = Array.from(new Set(chartsList));
                                               },
                                               reducerEditDesktopInputValues: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   state.desktopInputValues = action.payload || state.desktopInputValues;
                                               },
                                               reducerEditBoards: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   state.boardExists = action.payload;
                                               },
                                               reducerSelectChartsType: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   state.selectChartsType = action.payload;
                                               },
                                               reducerAddChartsList: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, chartId, type} = action.payload || {};
                                                   const index =
                                                       state.desktopList && Array.isArray(state.desktopList)
                                                       ? state.desktopList.findIndex(
                                                           (el: any) => el && el.id && el.id.toString() === id,
                                                       )
                                                       : -1;
                                                   const desktopFilters =
                                                       state.desktopInputValues && state.desktopInputValues[index]
                                                       ? state.desktopInputValues[index]
                                                       : {};
                                                   const desktopData =
                                                       state.desktopData && state.desktopData[id] ? state.desktopData[id] : [];
                                                   const existingChart =
                                                       Array.isArray(desktopData) && desktopData.length > 0
                                                       ? desktopData.find((item: any) => item && item.id === chartId)
                                                       : null;
                                                   const baseValues =
                                                       state.desktopInputValues &&
                                                       state.desktopInputValues[id] &&
                                                       state.desktopInputValues[id].generalFilters
                                                       ? state.desktopInputValues[id].generalFilters
                                                       : {};
                                                   const values =
                                                       state.desktopInputValues &&
                                                       state.desktopInputValues[id] &&
                                                       state.desktopInputValues[id][chartId]
                                                       ? state.desktopInputValues[id][chartId]
                                                       : {...defaultFilter, ...baseValues};

                                                   if (!desktopFilters || !desktopFilters.chartId) {
                                                       if (type === 'visit') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {...values, ...state.inputValues},
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataVisitCharts: [],
                                                                       dataPrecent: [],
                                                                       dataCircle: [],
                                                                       visitChart: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'bar',
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'oss') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {...values, ...state.inputValues},
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataOssCharts: [],
                                                                       dataCircle: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'bar',
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'actions') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {
                                                                       ...values,
                                                                       ...state.inputValues,
                                                                       group: {value: '6', label: 'По сети'},
                                                                   },
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataActionCharts: [],
                                                                       dataCircle: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'barStackedNorm',
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'sku') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {...values, ...state.inputValues},
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataPrecent: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'lineBar',
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'facing') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {...values, ...state.inputValues},
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataPrecent: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'bar',
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'rateStatus') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {...values, ...state.inputValues},
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataRateStatusCharts: [],
                                                                       dataCircle: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'barStacked',
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'checkStatus') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {...values, ...state.inputValues},
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataCircle: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'barStacked',
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'dynamics') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {...values, ...state.inputValues},
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataCircle: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'bar',
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'reportsChart') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {
                                                                       ...values,
                                                                       ...state.inputValues,
                                                                       status: 'RATE_STATUS',
                                                                   },
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataReportsCharts: [],
                                                                       labels: ['Проверен', 'Не проверен'],
                                                                   },
                                                               ];
                                                           }
                                                       } else if (type === 'tanderSignal') {
                                                           if (!existingChart) {
                                                               state.desktopInputValues[id] = {
                                                                   ...state.desktopInputValues[id],
                                                                   [chartId]: {...values, ...state.inputValues},
                                                               };

                                                               state.desktopData[id] = [
                                                                   ...desktopData,
                                                                   {
                                                                       id: chartId,
                                                                       dataSignalCharts: [],
                                                                       dataPrecent: [],
                                                                       dataCircle: [],
                                                                       signalChart: [],
                                                                       labels: [],
                                                                       periodList: [],
                                                                       type: 'bar',
                                                                   },
                                                               ];
                                                           }
                                                       }
                                                   }
                                                   if (!state.desktopInputValues[id]) {
                                                       state.desktopInputValues[id] = {
                                                           generalFilters: {
                                                               fromDate: stateDate(startOfMonth(subMonths(new Date(), 0))),
                                                               toDate: stateDate(new Date()),
                                                           },
                                                       };
                                                   } else {
                                                       state.desktopInputValues[id] = {
                                                           ...state.desktopInputValues[id],
                                                           generalFilters: state.desktopInputValues[id].generalFilters
                                                                           ? state.desktopInputValues[id].generalFilters
                                                                           : {
                                                                   fromDate: stateDate(startOfMonth(subMonths(new Date(), 0))),
                                                                   toDate: stateDate(new Date()),
                                                               },
                                                       };
                                                   }
                                               },
                                               reducerAddData: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, charts} = action.payload || {};
                                                   if (state.desktopList && Array.isArray(state.desktopList)) {
                                                       const index = state.desktopList.findIndex(
                                                           (el: any) => el && el.id && el.id.toString() === id,
                                                       );
                                                       if (index !== -1) {
                                                           state.desktopList[index] = {
                                                               ...state.desktopList[index],
                                                               list: charts,
                                                           };
                                                       }
                                                   }
                                               },
                                               reducerNewCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, charts} = action.payload || {};
                                                   if (state.desktopList && Array.isArray(state.desktopList)) {
                                                       const index = state.desktopList.findIndex(
                                                           (el: any) => el && el.id && el.id.toString() === id,
                                                       );
                                                       if (index !== -1) {
                                                           const elem = state.desktopList[index].list || [];
                                                           if (
                                                               (!elem || elem.length === 0) &&
                                                               charts &&
                                                               charts.chartsList &&
                                                               charts.chartsList.length !== 0
                                                           ) {
                                                               const newChartsList = charts.chartsList.map(
                                                                   (el: string, ind: number) => {
                                                                       return {id: ind, type: el, isCopy: false};
                                                                   },
                                                               );
                                                               state.data[index] = newChartsList;
                                                           } else if (charts && charts.chartsList && elem.length > 0) {
                                                               const incomingTypes = charts.chartsList;
                                                               const newList: any = elem.filter(
                                                                   (chart: { id: number; type: string; isCopy: boolean }) =>
                                                                       incomingTypes.includes(chart.type),
                                                               );
                                                               incomingTypes.forEach((type: string, ind: number) => {
                                                                   if (
                                                                       !elem.some(
                                                                           (chart: { id: number; type: string; isCopy: boolean }) =>
                                                                               chart.type === type,
                                                                       )
                                                                   ) {
                                                                       const allIds = [
                                                                           ...elem.map((item: { id: number }) => item.id),
                                                                           ...newList.map((chart: { id: number }) => chart.id),
                                                                       ];
                                                                       const newId = Math.max(...allIds, 0) + 1;
                                                                       const newChart = {id: newId, type, isCopy: false};
                                                                       newList.push(newChart);
                                                                   }
                                                               });
                                                               state.data[index] = newList;
                                                           } else if (
                                                               (charts && charts.chartsList && charts.chartsList.length === 0) ||
                                                               (charts &&
                                                                charts.chartsList &&
                                                                charts.chartsList.length === 0 &&
                                                                elem.length > 0)
                                                           ) {
                                                               state.data[index] = [];
                                                           }
                                                           state.desktopList[index] = {
                                                               ...state.desktopList[index],
                                                               list: state.data[index],
                                                           };
                                                           localStorage.setItem('charts', JSON.stringify(state.data));
                                                       }
                                                   }
                                               },
                                               reducerSelectCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   state.selectChart = action.payload;
                                               },
                                               reducerEditTypeChart: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       state.desktopData[pageId] &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       const index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                       if (index !== -1) {
                                                           state.desktopData[pageId][index] = {
                                                               ...state.desktopData[pageId][index],
                                                               type: data,
                                                           };
                                                       }
                                                   }
                                               },
                                               reducerGetVisitsCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       data &&
                                                       Array.isArray(data)
                                                   ) {
                                                       const dataCircle: number[] = [];
                                                       const labels: string[] = [];
                                                       const index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                       if (index === -1) return;
                                                       if (!state.visitChart) {
                                                           state.visitChart = [];
                                                       }
                                                       const resultArray = data.map(
                                                           (el: IVisitChartsOptions) => el.groupingKey,
                                                       );
                                                       const {acceptedTrue, acceptedFalse} = data.reduce(
                                                           (acc: any, item: any) => {
                                                               acc.acceptedTrue.push(item.acceptedCount);
                                                               acc.acceptedFalse.push(item.notAcceptedCount);
                                                               return acc;
                                                           },
                                                           {acceptedTrue: [], acceptedFalse: []},
                                                       );
                                                       const sumSubmitted = acceptedTrue.reduce(
                                                           (accumulator: number, currentValue: number) =>
                                                               accumulator + currentValue,
                                                           0,
                                                       );
                                                       const sumNoSubmitted = acceptedFalse.reduce(
                                                           (accumulator: number, currentValue: number) =>
                                                               accumulator + currentValue,
                                                           0,
                                                       );
                                                       if (sumSubmitted > 0) {
                                                           dataCircle.push(sumSubmitted);
                                                       }
                                                       if (sumNoSubmitted > 0) {
                                                           dataCircle.push(sumNoSubmitted);
                                                       }
                                                       if (data) {
                                                           const hasAccepted = data.some(
                                                               (el: IVisitChartsOptions) => el.acceptedCount,
                                                           );
                                                           const hasNotAccepted = data.some(
                                                               (el: IVisitChartsOptions) => el.notAcceptedCount,
                                                           );
                                                           if (hasAccepted) {
                                                               labels.push('сдан');
                                                           }
                                                           if (hasNotAccepted) {
                                                               labels.push('не сдан');
                                                           }
                                                       }
                                                       const procentAcceptedTrue: number[] = [];
                                                       const procentAcceptedFalse: number[] = [];
                                                       const getPrecentData = () => {
                                                           acceptedTrue.forEach((el: number, index: number) => {
                                                               const sum = el + acceptedFalse[index];
                                                               if (sum > 0) {
                                                                   procentAcceptedTrue.push(Math.round((el * 100) / sum));
                                                                   procentAcceptedFalse.push(
                                                                       Math.round((acceptedFalse[index] * 100) / sum),
                                                                   );
                                                               } else {
                                                                   procentAcceptedTrue.push(0);
                                                                   procentAcceptedFalse.push(0);
                                                               }
                                                           });
                                                       };
                                                       getPrecentData();
                                                       const dataCharts = labels.map((label: string) => {
                                                           return {
                                                               data: label === 'сдан' ? acceptedTrue : acceptedFalse,
                                                               label: label,
                                                           };
                                                       });
                                                       const dataChartsPrecent = labels.map((label: string) => {
                                                           return {
                                                               data: label === 'сдан' ? procentAcceptedTrue : procentAcceptedFalse,
                                                               label: label,
                                                           };
                                                       });
                                                       const typeCircleDatasets = {
                                                           label: ['сдан', 'не сдан'],
                                                           data: dataCircle,
                                                           borderWidth: 0,
                                                       };
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           labels: labels,
                                                           periodList: resultArray,
                                                           dataVisitCharts: dataCharts,
                                                           dataPrecent: dataChartsPrecent,
                                                           dataCircle: typeCircleDatasets,
                                                           visitChart: data,
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                               reducerGetSkuAverageCharts: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (!(data && Array.isArray(data))) return;
                                                   let groupped: string = 'skuName';
                                                   let index = 0;
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                   }
                                                   const newData: any[] = [];
                                                   data.forEach((el: any) => {
                                                       const firstKey = Object.keys(el)[0];
                                                       const dataValue = el[firstKey];
                                                       const values: number[] | undefined =
                                                           dataValue && typeof dataValue === 'object'
                                                           ? (Object.values(dataValue) as number[])
                                                           : undefined;
                                                       if (values && !values.every((value) => value === 0)) {
                                                           newData.push({[firstKey]: dataValue});
                                                       }
                                                   });
                                                   const getLabels = () => {
                                                       const skuName: Set<string> = new Set();
                                                       const subgroupName: Set<string> = new Set();
                                                       const groupName: Set<string> = new Set();
                                                       const subCategoryName: Set<string> = new Set();
                                                       const categoryName: Set<string> = new Set();
                                                       data.forEach((el: { [key: string]: any[] }) => {
                                                           const list = el[Object.keys(el)[0]] || [];
                                                           list.forEach(
                                                               (item: {
                                                                   subcategory: string;
                                                                   category: string;
                                                                   group: string;
                                                                   subgroup: string;
                                                                   skuName: string;
                                                                   avgFace: number;
                                                                   percentage: number;
                                                               }) => {
                                                                   skuName.add(item.skuName);
                                                                   subgroupName.add(item.subgroup);
                                                                   groupName.add(item.group);
                                                                   categoryName.add(item.category);
                                                                   subCategoryName.add(item.subcategory);
                                                               },
                                                           );
                                                       });

                                                       // выбираем максимальное количество элементов, но не более 20, подходящее для отображения на графике
                                                       const maxElementsToDisplay = Math.max(
                                                           skuName.size < 20 ? skuName.size : 0,
                                                           groupName.size < 20 ? groupName.size : 0,
                                                           subCategoryName.size < 20 ? subCategoryName.size : 0,
                                                           categoryName.size < 20 ? categoryName.size : 0,
                                                       );

                                                       switch (maxElementsToDisplay) {
                                                           case skuName.size:
                                                               groupped = 'skuName';
                                                               return Array.from(skuName);
                                                           case groupName.size:
                                                               groupped = 'group';
                                                               return Array.from(groupName);
                                                           case subCategoryName.size:
                                                               groupped = 'subCategory';
                                                               return Array.from(subCategoryName);
                                                           case categoryName.size:
                                                               groupped = 'category';
                                                               return Array.from(categoryName);
                                                           default:
                                                               groupped = 'skuName';
                                                               return Array.from(skuName);
                                                       }
                                                   };
                                                   let labels: string[] = getLabels();
                                                   const resyltList = labels.map((label: string) => {
                                                       const result1: any[] = [];
                                                       const counts: number[] = [];
                                                       const percents: number[] = [];
                                                       newData.forEach((el: any) => {
                                                           const key = Object.keys(el)[0];
                                                           const values = el[key] as [];
                                                           const filtersArr = Array.isArray(values)
                                                                              ? values.filter((obj: any) => obj[groupped] === label)
                                                                              : [];
                                                           const result = filtersArr.length
                                                                          ? filtersArr.reduce(
                                                                   (acc: any, value: any) => {
                                                                       acc.totalPercentage += value.percentage;
                                                                       acc.totalAvgFace += value.avgFace;
                                                                       return acc;
                                                                   },
                                                                   {totalPercentage: 0, totalAvgFace: 0},
                                                               )
                                                                          : {totalPercentage: 0, totalAvgFace: 0};
                                                           counts.push(result.totalAvgFace === 0 ? null : result.totalAvgFace);
                                                           percents.push(result.totalPercentage);
                                                           result1.push({[key]: result});
                                                       });
                                                       return {
                                                           [label]: {
                                                               counts,
                                                               percents,
                                                           },
                                                       };
                                                   });
                                                   const period = newData.map((el: any) => {
                                                       return Object.keys(el)[0];
                                                   });
                                                   const dataCharts = resyltList.map(
                                                       (el: { [key: string]: { counts: number[] } }) => {
                                                           return {
                                                               label: Object.keys(el)[0],
                                                               data: el[Object.keys(el)[0]].counts,
                                                               additionalData: period,
                                                               skipNull: true,
                                                           };
                                                       },
                                                   );
                                                   const dataChartsPrecent = resyltList.map(
                                                       (el: { [key: string]: { percents: number[] } }) => {
                                                           return {
                                                               label: Object.keys(el)[0],
                                                               data: el[Object.keys(el)[0]].percents,
                                                               additionalData: period,
                                                           };
                                                       },
                                                   );
                                                   const truncatedStrings = period.map((str: any) => {
                                                       if (typeof str === 'string' && str.length > 10) {
                                                           return str.substring(0, 15) + '...';
                                                       } else {
                                                           return str;
                                                       }
                                                   });
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       index !== -1
                                                   ) {
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           labels: labels,
                                                           groupped: groupped,
                                                           skuAverage: newData,
                                                           periodListOfDate: period,
                                                           dataSkuCharts: dataCharts,
                                                           periodList: truncatedStrings,
                                                           dataPrecent: dataChartsPrecent,
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                               reducerGetOssCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (!(data && Array.isArray(data))) return;
                                                   let groupingArray: any[] = [];
                                                   let hotlines: string[] = [];
                                                   let index = 0;
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                   }
                                                   const resultArray = data.map((item: any) => item[0]);
                                                   const totalCount = data.map((item: any) => {
                                                       const group =
                                                           item[1] && item[1].grouping && Array.isArray(item[1].grouping)
                                                           ? item[1].grouping[0]
                                                           : {};
                                                       return (
                                                           (group.blocked || 0) +
                                                           (group.availabilityByDate && group.availabilityByDate.available
                                                            ? group.availabilityByDate.available
                                                            : 0)
                                                       );
                                                   });
                                                   const extractPercentages = (dataKey: string) => {
                                                       return data.map((item: any, idx: number) => {
                                                           const group =
                                                               item[1] && item[1].grouping && Array.isArray(item[1].grouping)
                                                               ? item[1].grouping[0]
                                                               : {};
                                                           let value = 0;
                                                           if (dataKey === 'available') {
                                                               value = group.availabilityByDate
                                                                       ? group.availabilityByDate[dataKey] || 0
                                                                       : 0;
                                                           } else if (dataKey === 'blocked') {
                                                               value = group.blocked || 0;
                                                           } else if (group.hotlinesByDate && group.hotlinesByDate[dataKey]) {
                                                               value = group.hotlinesByDate[dataKey] || 0;
                                                           }
                                                           const percent = totalCount[idx] ? (value / totalCount[idx]) * 100 : 0;
                                                           return Number(percent.toFixed(2));
                                                       });
                                                   };
                                                   const extractCount = (dataKey: string) => {
                                                       return data.map((item: any) => {
                                                           const group =
                                                               item[1] && item[1].grouping && Array.isArray(item[1].grouping)
                                                               ? item[1].grouping[0]
                                                               : {};
                                                           if (dataKey === 'available') {
                                                               return Math.round(
                                                                   group.availabilityByDate
                                                                   ? group.availabilityByDate[dataKey] || 0
                                                                   : 0,
                                                               );
                                                           } else if (item[1] && group[dataKey] !== undefined) {
                                                               return Math.round(group[dataKey] || 0);
                                                           }
                                                           return 0;
                                                       });
                                                   };
                                                   data.forEach((item: any) => {
                                                       const grouping =
                                                           item[1] && item[1].grouping && Array.isArray(item[1].grouping)
                                                           ? item[1].grouping[0]
                                                           : {};
                                                       if (grouping.hotlinesByDate) {
                                                           hotlines = hotlines.concat(Object.keys(grouping.hotlinesByDate));
                                                       }
                                                       const transformedArray = grouping.hotlinesByDate
                                                                                ? Object.keys(grouping.hotlinesByDate).map((key) => ({
                                                               [key]: grouping.hotlinesByDate[key],
                                                           }))
                                                                                : hotlines.map((el: string) => ({[el]: null}));
                                                       groupingArray = groupingArray.concat(transformedArray);
                                                   });
                                                   const hotlinesLabels = Array.from(new Set(hotlines));
                                                   const availability = extractCount('available');
                                                   const availabilityPercentage = extractPercentages('available');
                                                   const resultGrouping: { [key: string]: number[] }[] = hotlinesLabels.map(
                                                       (el: string) => {
                                                           const res = data.map((item: any) => {
                                                               const valueList =
                                                                   item[1] && item[1].grouping && Array.isArray(item[1].grouping)
                                                                   ? item[1].grouping[0].hotlinesByDate
                                                                   : {};
                                                               return valueList && valueList[el] ? valueList[el] : null;
                                                           });
                                                           return {[el]: res};
                                                       },
                                                   );
                                                   const datesPercentCircle = (arr: string[]) => {
                                                       return arr.map((label: string) => {
                                                           const dataset =
                                                               label === 'в наличии'
                                                               ? availabilityPercentage
                                                               : label === 'проблема с товаром'
                                                                 ? extractPercentages('blocked')
                                                                 : extractPercentages(label);
                                                           const sum = dataset.reduce(
                                                               (accumulator: number, currentValue: number) =>
                                                                   accumulator + currentValue,
                                                               0,
                                                           );
                                                           return sum;
                                                       });
                                                   };
                                                   const dataCharts = ['в наличии', 'проблема с товаром'].map(
                                                       (label: string) => {
                                                           return {
                                                               data:
                                                                   label === 'в наличии' ? availability : extractCount('blocked'),
                                                               label: label,
                                                           };
                                                       },
                                                   );
                                                   const dataChartsPrecentege = ['в наличии', 'проблема с товаром'].map(
                                                       (label: string) => {
                                                           return {
                                                               data:
                                                                   label === 'в наличии'
                                                                   ? availabilityPercentage
                                                                   : extractPercentages('blocked'),
                                                               label: label,
                                                           };
                                                       },
                                                   );
                                                   const dataChartsHotlines = ['в наличии', ...hotlinesLabels].map(
                                                       (label: string) => {
                                                           const dataset =
                                                               label === 'в наличии'
                                                               ? availability
                                                               : resultGrouping.find(
                                                                   (el: { [key: string]: number[] }) =>
                                                                       label === Object.keys(el)[0],
                                                               );
                                                           return {
                                                               data:
                                                                   label === 'в наличии'
                                                                   ? dataset
                                                                   : dataset
                                                                     ? Object.values(dataset)[0]
                                                                     : [],
                                                               label: label,
                                                               skipNull: true,
                                                           };
                                                       },
                                                   );
                                                   const dataChartsHotlinesPercentage = ['в наличии', ...hotlinesLabels].map(
                                                       (label: string) => {
                                                           return {
                                                               data:
                                                                   label === 'в наличии'
                                                                   ? availabilityPercentage
                                                                   : extractPercentages(label),
                                                               label: label,
                                                           };
                                                       },
                                                   );
                                                   const dataCircle = [
                                                       datesPercentCircle(['в наличии', ...hotlinesLabels]),
                                                       datesPercentCircle(['в наличии', 'проблема с товаром']),
                                                   ];
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       index !== -1
                                                   ) {
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           periodList: resultArray,
                                                           dataOssCharts: dataCharts,
                                                           dataOssChartsPrecentege: dataChartsPrecentege,
                                                           ossCharts: data,
                                                           dataCircle: dataCircle,
                                                           dataChartsHotlines: dataChartsHotlines,
                                                           dataChartsHotlinesPercentage: dataChartsHotlinesPercentage,
                                                           labels: ['в наличии', ...hotlinesLabels],
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                               reducerGetActionsCharts: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   const dataCompleted: any = [];
                                                   const dataInCompleted: any = [];
                                                   const dataInCompletedHotline: any = [];
                                                   let labels: string[] = ['Стартовала'];
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (!(data && Array.isArray(data))) return;
                                                   let index = 0;
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                   }
                                                   const periodList = data.flatMap((item: any) => {
                                                       const groupedData = item && item.groupedData ? item.groupedData : {};
                                                       return groupedData && typeof groupedData === 'object'
                                                              ? Object.keys(groupedData)
                                                              : [];
                                                   });
                                                   const orderItems: any = Array.from(new Set(periodList));
                                                   orderItems.forEach((el: number, idx: number) => {
                                                       dataCompleted[idx] = {name: el, value: 0};
                                                       dataInCompleted[idx] = {name: el, value: 0};
                                                       dataInCompletedHotline[idx] = {name: el, hotlines: {}};
                                                   });
                                                   data.forEach((el: any) => {
                                                       if (el && el.groupedCompletion) {
                                                           for (const key in el.groupedCompletion) {
                                                               if (
                                                                   Object.prototype.hasOwnProperty.call(el.groupedCompletion, key)
                                                               ) {
                                                                   const findItem = dataCompleted.findIndex(
                                                                       (item: any) => item.name === key,
                                                                   );
                                                                   if (findItem !== -1) {
                                                                       const completedValue =
                                                                           Number(Object.values(el.groupedCompletion)[0]) || 0;
                                                                       dataCompleted[findItem].value = Math.floor(
                                                                           dataCompleted[findItem].value + completedValue,
                                                                       );
                                                                       dataInCompleted[findItem].value = Math.floor(
                                                                           dataInCompleted[findItem].value +
                                                                           (el.totalActions - completedValue),
                                                                       );
                                                                       if (el.incompleteHotlines) {
                                                                           const hotlines = Array.from(new Set(el.incompleteHotlines));
                                                                           dataInCompletedHotline[findItem].countHotline =
                                                                               el.incompleteHotlines.length;
                                                                           dataInCompletedHotline[findItem].percentageIncomplete =
                                                                               el.percentageIncomplete;
                                                                           hotlines.forEach((item: any) => {
                                                                               if (typeof item === 'string') {
                                                                                   if (!labels.includes(item)) {
                                                                                       labels.push(item);
                                                                                   }
                                                                                   dataInCompletedHotline[findItem].hotlines = {
                                                                                       ...dataInCompletedHotline[findItem].hotlines,
                                                                                       [item]: dataInCompletedHotline[findItem].hotlines[item]
                                                                                               ? dataInCompletedHotline[findItem].hotlines[item] +
                                                                                                 el.incompleteHotlines.filter(
                                                                                                     (hotline: any) => hotline === item,
                                                                                                 ).length
                                                                                               : el.incompleteHotlines.filter(
                                                                                               (hotline: any) => hotline === item,
                                                                                           ).length,
                                                                                   };
                                                                               }
                                                                           });
                                                                       }
                                                                   }
                                                               }
                                                           }
                                                       }
                                                   });
                                                   const extractPercentages = (label: string) => {
                                                       if (label === 'Стартовала') {
                                                           return dataCompleted.map((el: { value: number }, idx: number) => {
                                                               const total = dataCompleted[idx].value + dataInCompleted[idx].value;
                                                               return total ? (el.value / total) * 100 : 0;
                                                           });
                                                       } else if (label === 'Не стартовала') {
                                                           return dataInCompleted.map((el: { value: number }, idx: number) => {
                                                               const total = dataCompleted[idx].value + dataInCompleted[idx].value;
                                                               return total ? (el.value / total) * 100 : 0;
                                                           });
                                                       } else {
                                                           return dataInCompletedHotline.map(
                                                               (el: { hotlines: any }, idx: number) => {
                                                                   const item = el.hotlines[label] || 0;
                                                                   const total =
                                                                       dataCompleted[idx].value + dataInCompleted[idx].value;
                                                                   return total ? (item / total) * 100 : 0;
                                                               },
                                                           );
                                                       }
                                                   };
                                                   const newLabels = Array.from(new Set(labels));
                                                   const dataCharts = newLabels.map((label: string, idx: number) => {
                                                       return {
                                                           data: extractPercentages(label),
                                                           label,
                                                           additionalData: Array.from(new Set(periodList)),
                                                       };
                                                   });
                                                   const dataUnitedHotlines = ['Стартовала', 'Не стартовала'].map(
                                                       (label: string) => {
                                                           return {
                                                               data: extractPercentages(label),
                                                               label,
                                                               additionalData: Array.from(new Set(periodList)),
                                                           };
                                                       },
                                                   );
                                                   const totalForCircle = (): number => {
                                                       return ['Стартовала', 'Не стартовала']
                                                           .map((label: string) => {
                                                               const dataArr: number[] = extractPercentages(label);
                                                               return dataArr.reduce((acc: number, el: number) => acc + el, 0);
                                                           })
                                                           .reduce((acc: number, el: number) => acc + el, 0);
                                                   };
                                                   const totalSum = totalForCircle();
                                                   const dataForCircle = (labelsArr: string[]) => {
                                                       return labelsArr.map((label: string) => {
                                                           const dataArr = extractPercentages(label);
                                                           const sum = dataArr.reduce((acc: number, el: number) => acc + el, 0);
                                                           return totalSum ? (sum / totalSum) * 100 : 0;
                                                       });
                                                   };
                                                   const dataCircleHotlines = {
                                                       data: dataForCircle(newLabels),
                                                       borderWidth: 0,
                                                       labels: newLabels,
                                                   };
                                                   const dataCircleUnitedHotlines = {
                                                       data: dataForCircle(['Стартовала', 'Не стартовала']),
                                                       borderWidth: 0,
                                                       labels: newLabels,
                                                   };
                                                   const truncatedStrings = Array.from(new Set(periodList)).map(
                                                       (str: any) => {
                                                           if (typeof str === 'string' && str.length > 10) {
                                                               return str.substring(0, 15) + '...';
                                                           } else {
                                                               return str;
                                                           }
                                                       },
                                                   );
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       index !== -1
                                                   ) {
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           labels: newLabels.length ? newLabels : [],
                                                           actionsCharts: data,
                                                           periodList: truncatedStrings,
                                                           dataActionCharts: dataCharts,
                                                           dataCircle: dataCircleHotlines,
                                                           dataUnitedHotlines: dataUnitedHotlines,
                                                           dataCircleHotlines: dataCircleUnitedHotlines,
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                               reducerGetRateStatusCharts: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (!(data && Array.isArray(data))) return;
                                                   let index = 0;
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                   }
                                                   const resultArray = data.map((item: any) => item.groupingKey);
                                                   let labels: string[] = [];
                                                   data.forEach((el: any) => {
                                                       if (el && el.statusCounts) {
                                                           const keys = Object.keys(el.statusCounts);
                                                           labels = labels.concat(keys);
                                                       }
                                                   });
                                                   labels = Array.from(new Set(labels));
                                                   const extractData = (dataKey: string) => {
                                                       return data.map((item: any) => {
                                                           if (
                                                               item &&
                                                               item.statusCounts &&
                                                               item.statusCounts[dataKey] !== undefined
                                                           ) {
                                                               const percent = Number(item.statusCounts[dataKey].percentage) || 0;
                                                               const count = Number(item.statusCounts[dataKey].count) || 0;
                                                               const costFact = Number(item.statusCounts[dataKey].costFact) || 0;
                                                               return {percent, count, costFact};
                                                           }
                                                           return {percent: 0, count: 0, costFact: 0};
                                                       });
                                                   };
                                                   const dataCharts = labels.map((label: string) => {
                                                       const extracted = extractData(label);
                                                       const count = extracted.map((el: any) => el.count);
                                                       return {
                                                           data: count,
                                                           label: label,
                                                       };
                                                   });
                                                   const dataChartsPercent = labels.map((label: string) => {
                                                       const extracted = extractData(label);
                                                       const percent = extracted.map((el: any) => el.percent);
                                                       return {
                                                           data: percent,
                                                           label: label,
                                                           additionalData: [extracted.map((el: any) => el.count)],
                                                       };
                                                   });
                                                   const dataChartsCostFact = labels.map((label: string) => {
                                                       const extracted = extractData(label);
                                                       const costFact = extracted.map((el: any) => el.costFact);
                                                       return {
                                                           data: costFact,
                                                           label: label,
                                                       };
                                                   });
                                                   const listPercent = labels.map((label: string) => {
                                                       const extracted = extractData(label);
                                                       return extracted.map((el: any) => el.costFact);
                                                   });
                                                   const indexSums = Array(resultArray.length).fill(0);
                                                   listPercent.forEach((el: any) => {
                                                       el.forEach((value: any, i: any) => {
                                                           indexSums[i] += Number(value);
                                                       });
                                                   });
                                                   const costFactPercent = listPercent.map((item: any) => {
                                                       return item.map((value: any, i: number) => {
                                                           return indexSums[i] ? (Number(value) / indexSums[i]) * 100 : 0;
                                                       });
                                                   });
                                                   const dataChartsCostFactPercent = labels.map(
                                                       (label: string, idx: number) => {
                                                           const extracted = extractData(label);
                                                           const costFact = extracted.map((el: any) =>
                                                                                              Number(el.costFact).toFixed(2),
                                                           );
                                                           const count = extracted.map((el: any) => el.count);
                                                           return {
                                                               data: costFactPercent[idx],
                                                               label: label,
                                                               additionalData: [costFact, count],
                                                           };
                                                       },
                                                   );
                                                   const circleCount: any = [];
                                                   const circleCostFact: any = [];
                                                   labels.forEach((label: string) => {
                                                       const extracted = extractData(label);
                                                       const count = extracted.map((el: any) => el.count);
                                                       const sumtotalActions = count.reduce(
                                                           (acc: number, currentValue: number) =>
                                                               Number(acc) + Number(currentValue),
                                                           0,
                                                       );
                                                       circleCount.push(sumtotalActions);
                                                       const costFactVals = extracted.map((el: any) => el.costFact);
                                                       const sumcompleted = costFactVals.reduce(
                                                           (acc: number, currentValue: number) =>
                                                               Number(acc) + Number(currentValue),
                                                           0,
                                                       );
                                                       circleCostFact.push(sumcompleted.toFixed(2));
                                                   });
                                                   const circleData = {
                                                       costFact: circleCostFact,
                                                       count: circleCount,
                                                   };
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       index !== -1
                                                   ) {
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           labels: labels,
                                                           rateSatusCharts: data,
                                                           dataCircle: circleData,
                                                           dataRateStatusCharts: dataCharts,
                                                           dataPrecent: dataChartsPercent,
                                                           dataCostFact: dataChartsCostFact,
                                                           periodList: Array.from(new Set(resultArray)),
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                           dataCoastPrecent: dataChartsCostFactPercent,
                                                       };
                                                   }
                                               },
                                               reducerGetCheckStatusCharts: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (!(data && Array.isArray(data))) return;
                                                   let index = 0;
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                   }
                                                   const resultArray = data.map((item: any) => item.groupingKey);
                                                   let labels: string[] = [];
                                                   data.forEach((el: any) => {
                                                       if (el) {
                                                           const keys = Object.keys(el);
                                                           keys.forEach((key) => {
                                                               if (!finedData.includes(key)) {
                                                                   labels.push(key);
                                                               }
                                                           });
                                                       }
                                                   });
                                                   labels = Array.from(new Set(labels));
                                                   const extractData = (dataKey: string) => {
                                                       return data.map((item: any) => {
                                                           if (item && item[dataKey] !== undefined) {
                                                               const percent = item[dataKey].percentage;
                                                               return {
                                                                   percent: percent,
                                                                   count: item[dataKey].count,
                                                               };
                                                           }
                                                           return {
                                                               percent: 0,
                                                               count: 0,
                                                           };
                                                       });
                                                   };
                                                   const dataCharts = labels.map((label: string) => {
                                                       const extracted = extractData(label);
                                                       const count = extracted.map((el: any) => el.count);
                                                       return {
                                                           data: count,
                                                           label: label,
                                                       };
                                                   });
                                                   const dataChartsPercent = labels.map((label: string) => {
                                                       const extracted = extractData(label);
                                                       const percent = extracted.map((el: any) => el.percent);
                                                       const count = extracted.map((el: any) => el.count);
                                                       return {
                                                           data: percent,
                                                           label: label,
                                                           additionalData: [count],
                                                       };
                                                   });
                                                   const circleCount: any = [];
                                                   labels.forEach((label: string) => {
                                                       const extracted = extractData(label);
                                                       const count = extracted.map((el: any) => el.count);
                                                       const sumtotalActions = count.reduce(
                                                           (acc: number, currentValue: number) =>
                                                               Number(acc) + Number(currentValue),
                                                           0,
                                                       );
                                                       circleCount.push(sumtotalActions);
                                                   });
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       index !== -1
                                                   ) {
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           labels: labels,
                                                           circleData: circleCount,
                                                           periodList: resultArray,
                                                           dataPrecent: dataChartsPercent,
                                                           dataCheckStatusCharts: dataCharts,
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                               reducerGetFacingCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (!(data && Array.isArray(data))) return;
                                                   let groupped: string = 'skuName';
                                                   let index = 0;
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                   }
                                                   const getLabels = () => {
                                                       const skuName: Set<string> = new Set();
                                                       const subgroupName: Set<string> = new Set();
                                                       const groupName: Set<string> = new Set();
                                                       const subCategoryName: Set<string> = new Set();
                                                       const categoryName: Set<string> = new Set();
                                                       data.forEach((el: any) => {
                                                           const list =
                                                               el &&
                                                               el.dateSkuFaceData &&
                                                               Array.isArray(el.dateSkuFaceData) &&
                                                               el.dateSkuFaceData[0] &&
                                                               el.dateSkuFaceData[0].skuFaceSums
                                                               ? el.dateSkuFaceData[0].skuFaceSums
                                                               : [];
                                                           list.forEach(
                                                               (item: {
                                                                   subcategory: string;
                                                                   category: string;
                                                                   group: string;
                                                                   subgroup: string;
                                                                   skuName: string;
                                                                   totalFace: number;
                                                                   percentage: number;
                                                               }) => {
                                                                   skuName.add(item.skuName);
                                                                   subgroupName.add(item.subgroup);
                                                                   groupName.add(item.group);
                                                                   categoryName.add(item.category);
                                                                   subCategoryName.add(item.subcategory);
                                                               },
                                                           );
                                                       });

                                                       // выбираем максимальное количество элементов, но не более 20, подходящее для отображения на графике
                                                       const maxElementsToDisplay = Math.max(
                                                           skuName.size < 20 ? skuName.size : 0,
                                                           groupName.size < 20 ? groupName.size : 0,
                                                           subCategoryName.size < 20 ? subCategoryName.size : 0,
                                                           categoryName.size < 20 ? categoryName.size : 0,
                                                       );


                                                       switch (maxElementsToDisplay) {
                                                           case skuName.size:
                                                               groupped = 'skuName';
                                                               return Array.from(skuName).map(item => item === undefined ? UNCATHEGORIZED_ALIAS : item);
                                                           case groupName.size:
                                                               groupped = 'group';
                                                               return Array.from(groupName).map(item => item === undefined ? UNCATHEGORIZED_ALIAS : item);
                                                           case subCategoryName.size:
                                                               groupped = 'subCategory';
                                                               return Array.from(subCategoryName).map(item => item === undefined ? UNCATHEGORIZED_ALIAS : item);
                                                           case categoryName.size:
                                                               groupped = 'category';
                                                               return Array.from(categoryName).map(item => item === undefined ? UNCATHEGORIZED_ALIAS : item);
                                                           default:
                                                               groupped = 'skuName';
                                                               return Array.from(skuName).map(item => item === undefined ? UNCATHEGORIZED_ALIAS : item);
                                                       }
                                                   };
                                                   let labels: string[] = getLabels();
                                                   const resultArray = data.map((item: any) =>
                                                                                    item &&
                                                                                    item.dateSkuFaceData &&
                                                                                    Array.isArray(item.dateSkuFaceData) &&
                                                                                    item.dateSkuFaceData[0]
                                                                                    ? item.dateSkuFaceData[0].grouped
                                                                                    : '',
                                                   );

                                                   function groupData() {
                                                       return data && data.length
                                                              ? data.reduce((acc: any, item: any) => {
                                                               if (
                                                                   item &&
                                                                   item.dateSkuFaceData &&
                                                                   Array.isArray(item.dateSkuFaceData)
                                                               ) {
                                                                   item.dateSkuFaceData.forEach((dataItem: any) => {
                                                                       const key = dataItem.grouped;
                                                                       if (!acc[key]) {
                                                                           acc[key] = [];
                                                                       }
                                                                       acc[key] = acc[key].concat(dataItem.skuFaceSums);
                                                                   });
                                                               }
                                                               return acc;
                                                           }, {})
                                                              : {};
                                                   }

                                                   function transformDataCharts(skuNames: string[], dataArr: any) {
                                                       const result: any = {};
                                                       skuNames.forEach((sku: any) => {
                                                           result[sku || UNCATHEGORIZED_ALIAS] = new Array(dataArr.length).fill(null);
                                                       });
                                                       dataArr.forEach((arr: any, idx: number) => {
                                                           for (let key in arr) {
                                                               if (arr.hasOwnProperty(key) && skuNames.includes(key)) {
                                                                   result[key][idx] = arr[key];
                                                               } else {
                                                                   result[UNCATHEGORIZED_ALIAS][idx] = arr[key];
                                                               }

                                                           }
                                                       });
                                                       return Object.keys(result).map((sku) => ({[sku]: result[sku]}));
                                                   }

                                                   function sumSkuFaces(inputArray: any) {
                                                       return inputArray && inputArray.length
                                                              ? inputArray.reduce((acc: any, item: any) => {
                                                               const name = item[groupped];
                                                               const totalFace = item.totalFace;
                                                               if (acc[name]) {
                                                                   acc[name] += totalFace;
                                                               } else {
                                                                   acc[name] = totalFace;
                                                               }
                                                               return acc;
                                                           }, {})
                                                              : {};
                                                   }

                                                   function sumSkuFacesPercent(inputArray: any) {
                                                       return inputArray && inputArray.length
                                                              ? inputArray.reduce((acc: any, item: any) => {
                                                               const name = item[groupped];
                                                               const percentage = item.percentage;
                                                               if (acc[name]) {
                                                                   acc[name] += percentage;
                                                               } else {
                                                                   acc[name] = percentage;
                                                               }
                                                               return acc;
                                                           }, {})
                                                              : {};
                                                   }

                                                   const dataList = groupData();
                                                   const resultArray1 = [];
                                                   const resultArrayPercent: any = [];
                                                   for (let key in dataList) {
                                                       if (dataList.hasOwnProperty(key)) {
                                                           const summedData = sumSkuFaces(dataList[key]);
                                                           resultArray1.push(summedData);
                                                       }
                                                   }
                                                   for (let key in dataList) {
                                                       if (dataList.hasOwnProperty(key)) {
                                                           const summedData = sumSkuFacesPercent(dataList[key]);
                                                           resultArrayPercent.push(summedData);
                                                       }
                                                   }
                                                   const listCharts = transformDataCharts(labels, resultArray1);
                                                   const listPercent = transformDataCharts(labels, resultArray1);
                                                   const indexSums = Array(labels.length).fill(0);
                                                   listPercent.forEach((obj: any) => {
                                                       const values = Object.values(obj)[0];
                                                       if (Array.isArray(values)) {
                                                           values.forEach((value: any, i: number) => {
                                                               indexSums[i] += value;
                                                           });
                                                       }
                                                   });
                                                   listPercent.forEach((obj: any) => {
                                                       const key = Object.keys(obj)[0];
                                                       obj[key] = obj[key].map((value: any, i: any) => {
                                                           return indexSums[i] ? (value / indexSums[i]) * 100 : 0;
                                                       });
                                                   });
                                                   const dataCharts = listCharts.map((el: any) => {
                                                       return {
                                                           data: Object.values(el)[0],
                                                           label: Object.keys(el)[0],
                                                           additionalData: Array.from(new Set(resultArray)),
                                                           skipNull: true,
                                                       };
                                                   });
                                                   const dataChartsPercent = listPercent.map((el: any) => {
                                                       return {
                                                           data: Object.values(el)[0],
                                                           label: Object.keys(el)[0],
                                                           additionalData: Array.from(new Set(resultArray)),
                                                           skipNull: true,
                                                       };
                                                   });
                                                   const truncatedStrings = Array.from(new Set(resultArray)).map(
                                                       (str: any) => {
                                                           if (typeof str === 'string' && str.length > 10) {
                                                               return str.substring(0, 15) + '...';
                                                           } else {
                                                               return str;
                                                           }
                                                       },
                                                   );
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       index !== -1
                                                   ) {
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           labels,
                                                           groupped,
                                                           periodListOfDate: Array.from(new Set(resultArray)),
                                                           dataFacingCharts: dataCharts,
                                                           dataPrecent: dataChartsPercent,
                                                           periodList: truncatedStrings,
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                               reducerGetDynamicsCharts: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (!data) return;
                                                   let index = 0;
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                   }
                                                   const sortedData = Object.entries(data).sort((a: any, b: any) => {
                                                       const dateA = new Date(a[1].groupingKey).getTime();
                                                       const dateB = new Date(b[1].groupingKey).getTime();
                                                       return dateA - dateB;
                                                   });
                                                   const resultArray = sortedData.map((item: any) => item[1].groupingKey);

                                                   function transformDataCharts(skuNames: string[], dataArr: any) {
                                                       const result: any = {};
                                                       skuNames.forEach((sku: any) => {
                                                           result[sku] = new Array(dataArr.length).fill(0);
                                                       });
                                                       dataArr.forEach((el: any, idx: number) => {
                                                           const arr = el[1];
                                                           for (let key in arr) {
                                                               if (arr.hasOwnProperty(key) && skuNames.includes(key)) {
                                                                   result[key][idx] = arr[key];
                                                               }
                                                           }
                                                       });
                                                       return Object.keys(result).map((sku) => ({[sku]: result[sku]}));
                                                   }

                                                   const list = transformDataCharts(['approved', 'rejected'], sortedData);
                                                   const dataCharts = list.map((el: any) => {
                                                       const values = Object.values(el)[0] as { count: number }[];
                                                       const dataset = values.map((item: any) => Math.floor(item.count));
                                                       return {
                                                           data: dataset,
                                                           label: Object.keys(el)[0],
                                                       };
                                                   });
                                                   const dataChartsCostFact = list.map((el: any) => {
                                                       const values = Object.values(el)[0] as { costFact: number }[];
                                                       const dataset = values.map((item: any) => item.costFact);
                                                       return {
                                                           data: dataset,
                                                           label: Object.keys(el)[0],
                                                       };
                                                   });
                                                   const dataChartsPercent = list.map((el: any) => {
                                                       const values = Object.values(el)[0] as { count: number }[];
                                                       const dataset = values.map((item: any) => item.percentage);
                                                       return {
                                                           data: dataset,
                                                           label: Object.keys(el)[0],
                                                       };
                                                   });
                                                   const extractData = (dataKey: string) => {
                                                       const listData =
                                                           dataKey === 'approved' ? list[0].approved : list[1].rejected;
                                                       return listData.map((item: any, idx: number) => {
                                                           if (item) {
                                                               const percent = item.percentage;
                                                               const valueOver =
                                                                   dataKey === 'approved' ? list[1].rejected : list[0].approved;
                                                               return {
                                                                   percent: percent.toFixed(2),
                                                                   count: item.count.toFixed(0),
                                                                   costFact: item.costFact,
                                                                   costFactPercent:
                                                                       item.costFact && valueOver[idx] && valueOver[idx].costFact
                                                                       ? (item.costFact /
                                                                          (item.costFact + valueOver[idx].costFact)) *
                                                                         100
                                                                       : 0,
                                                               };
                                                           }
                                                           return {
                                                               percent: 0,
                                                               count: 0,
                                                           };
                                                       });
                                                   };
                                                   const circleCount: any = [];
                                                   const circleCostFact: any = [];
                                                   ['approved', 'rejected'].forEach((label: string) => {
                                                       const extracted = extractData(label);
                                                       const countArr = extracted.map((item: any) => item.count);
                                                       const costFactArr = extracted.map((item: any) => item.costFact);
                                                       const sumCount = countArr.reduce(
                                                           (acc: number, cur: any) => Number(acc) + Number(cur),
                                                           0,
                                                       );
                                                       const sumCostFact = costFactArr.reduce(
                                                           (acc: number, cur: any) => Number(acc) + Number(cur),
                                                           0,
                                                       );
                                                       if (sumCount > 0) {
                                                           circleCount.push(sumCount);
                                                       }
                                                       if (sumCostFact > 0) {
                                                           circleCostFact.push(sumCostFact);
                                                       }
                                                   });
                                                   const total = circleCount.reduce(
                                                       (acc: number, cur: number) => acc + cur,
                                                       0,
                                                   );
                                                   const circlePercentage = circleCount.map((cnt: number) =>
                                                                                                total ? (cnt / total) * 100 : 0,
                                                   );
                                                   const circleData = {
                                                       costFact: circleCostFact,
                                                       percentage: circlePercentage,
                                                       count: circleCount,
                                                   };
                                                   const dataChartsCostFactPercent = ['approved', 'rejected'].map(
                                                       (label: string, idx: number) => {
                                                           const extracted = extractData(label);
                                                           const costFactPercents = extracted.map(
                                                               (item: any) => item.costFactPercent,
                                                           );
                                                           return {
                                                               data: costFactPercents,
                                                               label: label,
                                                           };
                                                       },
                                                   );
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       index !== -1
                                                   ) {
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           dataCircle: circleData,
                                                           dataDynamicsCharts: dataCharts,
                                                           dataPrecent: dataChartsPercent,
                                                           dataCostFact: dataChartsCostFact,
                                                           dataCoastPrecent: dataChartsCostFactPercent,
                                                           labels: ['approved', 'rejected'],
                                                           periodList: Array.from(new Set(resultArray)),
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                               reducerGetReportsCharts: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (!(data && Array.isArray(data))) return;
                                                   let index = 0;
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId])
                                                   ) {
                                                       index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                   }
                                                   const checked = data.map((item: any) => item.checked || 0);
                                                   const noChecked = data.map((item: any) => item.notChecked || 0);
                                                   const sum = (arr: number[]) => arr.reduce((acc, cur) => acc + cur, 0);
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       index !== -1
                                                   ) {
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           dataReportsCharts: {cheked: sum(checked), noCheked: sum(noChecked)},
                                                           labels: ['Проверен', 'Не проверен'],
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                               reducerChartsFilters: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {pageId, id, data} = action.payload || {};
                                                   const filteredData: any = {...data};
                                                   if (data && typeof data === 'object') {
                                                       Object.keys(data).forEach((key) => {
                                                           const value = data[key];
                                                           if (value && Array.isArray(value) && value.length === 0) {
                                                               delete filteredData[key];
                                                           }
                                                       });
                                                   }
                                                   if (state.desktopInputValues && state.desktopInputValues[pageId]) {
                                                       state.desktopInputValues[pageId][id] = filteredData;
                                                   }
                                               },
                                               reducerModalFilters: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const payload = action.payload || defaultFilter;
                                                   state.modalFilters = {
                                                       ...payload,
                                                       groupFilters:
                                                           state.modalFilters && state.modalFilters.groupFilters
                                                           ? state.modalFilters.groupFilters
                                                           : {},
                                                   };
                                                   const initialPos = state.modalFilters.groupFilters && Array.isArray(state.modalFilters.groupFilters.pos)
                                                       ? state.modalFilters.groupFilters.pos : [];
                                                   const signalPos = state.signalFiltersOptions && Array.isArray(state.signalFiltersOptions.pos)
                                                       ? state.signalFiltersOptions.pos : [];
                                                   const initialChain = state.modalFilters.groupFilters && Array.isArray(state.modalFilters.groupFilters.chain)
                                                       ? state.modalFilters.groupFilters.chain : [];
                                                   const signalChain = state.signalFiltersOptions && Array.isArray(state.signalFiltersOptions.chain)
                                                       ? state.signalFiltersOptions.chain : [];
                                                   let filteredPos = [...initialPos, ...signalPos];
                                                   let filteredChains = [...initialChain, ...signalChain];
                                                   if (
                                                       payload.regions &&
                                                       Array.isArray(payload.regions) &&
                                                       payload.regions.length > 0
                                                   ) {
                                                       filteredPos = filteredPos.filter((el: any) =>
                                                                                            payload.regions.includes(Number(el.region)),
                                                       );
                                                       filteredChains = filteredChains.filter(
                                                           (el: any) =>
                                                               el &&
                                                               Array.isArray(el.regions) &&
                                                               el.regions.some((region: number) =>
                                                                                   payload.regions.includes(region),
                                                               ),
                                                       );
                                                   }
                                                   if (
                                                       payload.areas &&
                                                       Array.isArray(payload.areas) &&
                                                       payload.areas.length > 0
                                                   ) {
                                                       filteredPos = filteredPos.filter((el: any) =>
                                                                                            payload.areas.includes(Number(el.area)),
                                                       );
                                                   }
                                                   if (
                                                       payload.retailChains &&
                                                       Array.isArray(payload.retailChains) &&
                                                       payload.retailChains.length > 0
                                                   ) {
                                                       state.modalFilters = {
                                                           ...state.modalFilters,
                                                           retailChains:
                                                               state.modalFilters.retailChains &&
                                                               Array.isArray(state.modalFilters.retailChains)
                                                               ? state.modalFilters.retailChains.filter((id: any) =>
                                                                                                            filteredChains.some((el: any) => el && el.value === id),
                                                               )
                                                               : [],
                                                       };
                                                       filteredPos = filteredPos.filter((el: any) =>
                                                                                            payload.retailChains.includes(Number(el.chain)),
                                                       );
                                                   }
                                                   if (
                                                       payload.posIds &&
                                                       Array.isArray(payload.posIds) &&
                                                       payload.posIds.length > 0
                                                   ) {
                                                       state.modalFilters = {
                                                           ...state.modalFilters,
                                                           posIds:
                                                               state.modalFilters.posIds &&
                                                               Array.isArray(state.modalFilters.posIds)
                                                               ? state.modalFilters.posIds.filter((id: any) =>
                                                                                                      filteredPos.some((el: any) => el && el.value === id),
                                                               )
                                                               : [],
                                                       };
                                                   }
                                                   state.pos = filteredPos;
                                                   state.chain = filteredChains;
                                               },
                                               reducerGroups: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const sortedList = action.payload ? {...action.payload} : {};
                                                   for (const key in sortedList) {
                                                       if (
                                                           Array.isArray(sortedList[key]) &&
                                                           sortedList[key].length > 0 &&
                                                           sortedList[key][0] &&
                                                           sortedList[key][0].label
                                                       ) {
                                                           sortedList[key].sort((a: any, b: any) =>
                                                                                    a.label.localeCompare(b.label),
                                                           );
                                                       }
                                                   }
                                                   state.groupFilters = {...sortedList};
                                                   state.pos = state.groupFilters.pos;
                                                   state.chain = state.groupFilters.chain;
                                                   state.globalChainOptions = state.groupFilters.chain;
                                               },
                                               reducerGetModalFilter: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const payload = action.payload || {};
                                                   state.modalFilters.groupFilters = {...payload};
                                                   state.pos = payload.pos;
                                                   state.chain = payload.chain;
                                               },
                                               reducerChangeDataCharts: (
                                                   state: Draft<any>,
                                                   action: PayloadAction<any>,
                                               ) => {
                                                   state.changeDataCharts = action.payload;
                                               },
                                               reducerSettingCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   state.settingCharts = {...state.settingCharts, ...action.payload};
                                               },
                                               reducerPendingCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, selectId} = action.payload || {};
                                                   if (id !== undefined && selectId !== undefined) {
                                                       if (state.pending && state.pending[id]) {
                                                           if (state.pending[id].includes(selectId)) {
                                                               const newlist = state.pending[id].filter(
                                                                   (item: number) => item !== selectId,
                                                               );
                                                               state.pending[id] = newlist;
                                                           } else {
                                                               state.pending[id] = [...state.pending[id], selectId];
                                                           }
                                                       } else {
                                                           state.pending[id] = [selectId];
                                                       }
                                                   }
                                               },
                                               reducerClearChartsInputValues: () => {
                                                   return initialState;
                                               },
                                               reducerGetSignalCharts: (state: Draft<any>, action: PayloadAction<any>) => {
                                                   const {id, data, pageId} = action.payload || {};
                                                   if (
                                                       pageId &&
                                                       state.desktopData &&
                                                       Array.isArray(state.desktopData[pageId]) &&
                                                       data &&
                                                       Array.isArray(data)
                                                   ) {
                                                       const dataCircle: number[] = [];
                                                       const labels: string[] = [];
                                                       const index = state.desktopData[pageId].findIndex(
                                                           (el: any) => el && el.id === id,
                                                       );
                                                       if (index === -1) return;
                                                       if (!state.signalChart) {
                                                           state.signalChart = [];
                                                       }
                                                       const resultArray = data.map(
                                                           (el: ISignalChartsOptions) => el.groupingKey,
                                                       );
                                                       const {skipped, handled, completed} = data.reduce(
                                                           (acc: any, item: any) => {
                                                               acc.skipped.push(item.skippedCount);
                                                               acc.handled.push(item.handledCount);
                                                               acc.completed.push(item.completedCount);
                                                               return acc;
                                                           },
                                                           {skipped: [], handled: [], completed: []},
                                                       );
                                                       const sumSkipped = skipped.reduce(
                                                           (accumulator: number, currentValue: number) =>
                                                               accumulator + currentValue,
                                                           0,
                                                       );
                                                       const sumHandled = handled.reduce(
                                                           (accumulator: number, currentValue: number) =>
                                                               accumulator + currentValue,
                                                           0,
                                                       );
                                                       const sumCompleted = completed.reduce(
                                                           (accumulator: number, currentValue: number) =>
                                                               accumulator + currentValue,
                                                           0,
                                                       );
                                                       if (sumSkipped > 0) {
                                                           dataCircle.push(sumSkipped);
                                                       }
                                                       if (sumHandled > 0) {
                                                           dataCircle.push(sumHandled);
                                                       }
                                                       if (sumCompleted > 0) {
                                                           dataCircle.push(sumCompleted);
                                                       }
                                                       if (data) {
                                                           const hasSkipped = data.some(
                                                               (el: ISignalChartsOptions) => el.skippedCount,
                                                           );
                                                           const hasHandled = data.some(
                                                               (el: ISignalChartsOptions) => el.handledCount,
                                                           );
                                                           const hasCompleted = data.some(
                                                               (el: ISignalChartsOptions) => el.completedCount,
                                                           );

                                                           if (hasSkipped) {
                                                               labels.push('Пропущены');
                                                           }
                                                           if (hasHandled) {
                                                               labels.push('Сданы');
                                                           }
                                                           if (hasCompleted) {
                                                               labels.push('Отработаны');
                                                           }
                                                       }
                                                       const percentSkipped: number[] = [];
                                                       const percentHandled: number[] = [];
                                                       const percentCompleted: number[] = [];
                                                       const getPrecentData = () => {
                                                           completed.forEach((el: number, index: number) => {
                                                               const sum = el + handled[index] + skipped[index];
                                                               if (sum > 0) {
                                                                   percentCompleted.push(Math.round((el * 100) / sum));
                                                                   percentHandled.push(Math.round((handled[index] * 100) / sum));
                                                                   percentSkipped.push(Math.round((skipped[index] * 100) / sum));
                                                               } else {
                                                                   percentSkipped.push(0);
                                                                   percentHandled.push(0);
                                                                   percentCompleted.push(0);
                                                               }
                                                           });
                                                       };
                                                       getPrecentData();
                                                       const dataCharts = labels.map((label: string) => {
                                                           return {
                                                               data: label === 'Пропущены' ? skipped : (label === 'Сданы' ? handled : completed),
                                                               label: label,
                                                           };
                                                       });
                                                       const dataChartsPrecent = labels.map((label: string) => {
                                                           return {
                                                               data: label === 'Пропущены' ? percentSkipped : (label === 'Сданы' ? percentHandled : percentCompleted),
                                                               label: label,
                                                           };
                                                       });
                                                       const typeCircleDatasets = {
                                                           label: ['Пропущены', 'Сданы', 'Отработаны'],
                                                           data: dataCircle,
                                                           borderWidth: 0,
                                                       };
                                                       state.desktopData[pageId][index] = {
                                                           id: id,
                                                           labels: labels,
                                                           periodList: resultArray,
                                                           dataSignalCharts: dataCharts,
                                                           dataPrecent: dataChartsPrecent,
                                                           dataCircle: typeCircleDatasets,
                                                           signalChart: data,
                                                           type:
                                                               state.desktopData[pageId][index] &&
                                                               state.desktopData[pageId][index].type
                                                               ? state.desktopData[pageId][index].type
                                                               : 'bar',
                                                       };
                                                   }
                                               },
                                           },
                                       });

export const {
    reducerEditDesktopInputValues,
    reducerClearChartsInputValues,
    reducerGetCheckStatusCharts,
    reducerGetSkuAverageCharts,
    reducerGetRateStatusCharts,
    reducerGetDynamicsCharts,
    reducerChartsInputValues,
    reducerGetReportsCharts,
    reducerChangeDataCharts,
    reducerSelectChartsType,
    reducerGetActionsCharts,
    reducerEditOrderDesktop,
    reducerGetVisitsCharts,
    reducerGetFacingCharts,
    reducerGetModalFilter,
    reducerDesktopSetting,
    reducerPendingCharts,
    reducerSettingCharts,
    reducerAddChartsList,
    reducerChartsFilters,
    reducerEditTypeChart,
    reducerModalFilters,
    reducerGetOssCharts,
    reducerSelectCharts,
    reducerDesktopName,
    reducerGetDesktops,
    reducerGetSignalFilterOptions,
    reducerEditDesktop,
    reducerAddCharts,
    reducerNewCharts,
    reducerAddData,
    reducerGroups,
    reducerGetSignalCharts,
} = chartsSlice.actions;

export default chartsSlice.reducer;
